import React from "react";
import { Input } from "antd";
import { useState, useEffect } from "react";

const AdminLogsHistorySearch = ({ logHistoryData, sendSearchedArray }) => {
  const [searchedLogsHistory, setSearchedLogsHistory] = useState(null);

  useEffect(() => {
    sendSearchedArray(searchedLogsHistory);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [JSON.stringify(searchedLogsHistory)]);

  const onSearchLogsHistory = (e) => {
    const searchedArray = logHistoryData?.filter((object) =>
      Object.keys(object).some((key) => {
        if (
          key !== "data" &&
          key !== "exception" &&
          key !== "id" &&
          key !== "key" &&
          key !== "time" &&
          key !== "type" &&
          key !== "user" &&
          key !== "userId"
        ) {
          return String(object[key])
            .toLowerCase()
            .includes(e.target.value.toLowerCase());
        }
        return null;
      })
    );
    setSearchedLogsHistory(searchedArray);
  };

  return (
    <div className="admin-logs-history-search-container">
      <Input onChange={(e) => onSearchLogsHistory(e)} placeholder="Търсене" />
    </div>
  );
};

export default AdminLogsHistorySearch;
